"use client";
import { jsx as i } from "react/jsx-runtime";
import * as r from "@radix-ui/react-aspect-ratio";
import { forwardRef as s } from "react";
const a = s((t, o) => /* @__PURE__ */ i(r.Root, { "data-slot": "aspect-ratio", ...t, ref: o }));
a.displayName = "AspectRatio";
export {
  a as AspectRatio
};
